module.exports = __webpack_public_path__ + "static/media/0.75f646d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyebrowes/0.png
// module id = 1193
// module chunks = 0